(function () {
  if (window.__kailaColorGuideInit) return;
  window.__kailaColorGuideInit = true;

    var CATEGORY_WEIGHTS = {
      skin_color: 0.45,
      natural_hair_color: 0.35,
      eye_color: 0.2
    };

    var SCORES = {
      natural_hair_color: {
        black: { warmth: -1, lightness: -5, contrast: 5 },
        'very-dark-brown': { warmth: 1, lightness: -4, contrast: 4 },
        'dark-brown': { warmth: 2, lightness: -3, contrast: 3 },
        'medium-brown': { warmth: 2, lightness: -1, contrast: 1 },
        'light-brown': { warmth: 3, lightness: 1, contrast: -1 },
        'dark-blonde': { warmth: 2, lightness: 3, contrast: -2 },
        blonde: { warmth: 1, lightness: 5, contrast: -4 },
        'light-medium-red': { warmth: 5, lightness: 4, contrast: -3 },
        'red-auburn': { warmth: 5, lightness: -1, contrast: 2 },
        'platinum-white': { warmth: -2, lightness: 5, contrast: 4 }
      },
      eye_color: {
        'dark-brown': { warmth: 2, contrast: 4 },
        'medium-brown': { warmth: 2, contrast: 2 },
        hazel: { warmth: 4, contrast: 1 },
        green: { warmth: 1, contrast: 0 },
        blue: { warmth: -3, contrast: 0 },
        grey: { warmth: -4, contrast: -1 }
      },
      skin_color: {
        'very-deep': { lightness: -5 },
        deep: { lightness: -4 },
        tan: { lightness: -2 },
        medium: { lightness: 0 },
        'light-medium': { lightness: 1 },
        light: { lightness: 3 },
        fair: { lightness: 4 },
        'very-fair': { lightness: 5 }
      }
    };

    var COLOR_MODELS = [
      { name: 'Aino', slug: 'aino', hair: 'platinum-white', eyes: 'blue', skin: 'very-fair', warmth: -2, lightness: 10, contrast: 1 },
      { name: 'Bailey', slug: 'bailey', hair: 'red-auburn', eyes: 'hazel', skin: 'fair', warmth: 9, lightness: 3, contrast: 7 },
      { name: 'Cecilia', slug: 'cecilia', hair: 'black', eyes: 'dark-brown', skin: 'tan', warmth: 1, lightness: -7, contrast: 14 },
      { name: 'Emilie', slug: 'emilie', hair: 'very-dark-brown', eyes: 'medium-brown', skin: 'light-medium', warmth: 3, lightness: -1, contrast: 9 },
      { name: 'Freya', slug: 'freya', hair: 'platinum-white', eyes: 'blue', skin: 'very-fair', warmth: -3, lightness: 10, contrast: 2 },
      { name: 'Ksenia', slug: 'ksenia', hair: 'medium-brown', eyes: 'blue', skin: 'fair', warmth: -1, lightness: 3, contrast: 5 },
      { name: 'Lucia', slug: 'lucia', hair: 'dark-brown', eyes: 'medium-brown', skin: 'light-medium', warmth: 1, lightness: -7, contrast: 14 },
      { name: 'Mei', slug: 'mei', hair: 'black', eyes: 'dark-brown', skin: 'light-medium', warmth: 1, lightness: -2, contrast: 14 },
      { name: 'Niamh', slug: 'niamh', hair: 'light-medium-red', eyes: 'green', skin: 'very-fair', warmth: 2, lightness: 14, contrast: -2 },
      { name: 'Hafsatu', slug: 'hafsatu', hair: 'black', eyes: 'dark-brown', skin: 'very-deep', warmth: 1, lightness: -10, contrast: 14 },
      { name: 'Priya', slug: 'priya', hair: 'black', eyes: 'dark-brown', skin: 'tan', warmth: 1, lightness: -7, contrast: 14 },
      { name: 'Rima', slug: 'rima', hair: 'black', eyes: 'dark-brown', skin: 'tan', warmth: 1, lightness: -4, contrast: 14 },
      { name: 'Oko', slug: 'oko', hair: 'black', eyes: 'hazel', skin: 'deep', warmth: 2, lightness: -6, contrast: 14 },
      { name: 'Yoki', slug: 'yoki', hair: 'black', eyes: 'dark-brown', skin: 'tan', warmth: 1, lightness: -7, contrast: 14 },
      { name: 'Zofia', slug: 'zofia', hair: 'dark-brown', eyes: 'blue', skin: 'fair', warmth: -2, lightness: 2, contrast: 9 }
    ];

    var RATING_TIERS = [
      { maxDistance: 6, stars: 5, label: 'Excellent' },
      { maxDistance: 10, stars: 4, label: 'Very good' },
      { maxDistance: 14, stars: 3, label: 'Good' },
      { maxDistance: 18, stars: 2, label: 'Can work depending on the outfit' },
      { maxDistance: Infinity, stars: 1, label: 'Probably not your strongest colors' }
    ];

    var COLOR_RATING_TIERS = [
      { maxDistance: 2.5, stars: 5, label: 'Excellent' },
      { maxDistance: 4, stars: 4, label: 'Very good' },
      { maxDistance: 5.5, stars: 3, label: 'Good' },
      { maxDistance: 7.5, stars: 2, label: 'Can work depending on the outfit' },
      { maxDistance: Infinity, stars: 1, label: 'Probably not your strongest colors' }
    ];

    var AYAMI_COLORS = [
      { name: 'Snow White', slug: 'snow-white', warmth: 0, lightness: 5, contrast: 5, hex: '#FFFFFF' },
      { name: 'Agate Beige', slug: 'agate-beige', warmth: 4, lightness: 3, contrast: -2, hex: '#B0A08D' },
      { name: 'Twilight Blue', slug: 'twilight-blue', warmth: -5, lightness: -4, contrast: 4, hex: '#2B2749' },
      { name: 'Ocean Blue', slug: 'ocean-blue', warmth: -2, lightness: 2, contrast: 1, hex: '#487BB3' },
      { name: 'Forest Green', slug: 'forest-green', warmth: 1, lightness: -2, contrast: 2, hex: '#5A5F47' },
      { name: 'Wine Red', slug: 'wine-red', warmth: -1, lightness: -3, contrast: 3, hex: '#5C1426' },
      { name: 'Espresso Brown', slug: 'espresso-brown', warmth: 3, lightness: -4, contrast: 3, hex: '#533D28' },
      { name: 'Midnight Black', slug: 'midnight-black', warmth: 0, lightness: -5, contrast: 5, hex: '#000000' }
    ];

    var MODEL_COLOR_SCALE = { warmth: 9, lightness: 14, contrast: 14 };

    var HAIR_ORDER = [
      'black', 'very-dark-brown', 'dark-brown', 'medium-brown', 'light-brown',
      'dark-blonde', 'light-medium-red', 'red-auburn', 'blonde', 'platinum-white'
    ];

    var SKIN_ORDER = [
      'very-deep', 'deep', 'tan', 'medium', 'light-medium', 'light', 'fair', 'very-fair'
    ];

    var OPTION_SWATCHES = {
      natural_hair_color: {
        black: '#1A1A1A',
        'very-dark-brown': '#2C1810',
        'dark-brown': '#4A3728',
        'medium-brown': '#6B4423',
        'light-brown': '#8B6914',
        'dark-blonde': '#A67C52',
        'light-medium-red': '#B55239',
        'red-auburn': '#8B3A3A',
        blonde: '#D4B896',
        'platinum-white': '#F0EBE3'
      },
      eye_color: {
        black: '#1A1A1A',
        'dark-brown': '#3D2314',
        'medium-brown': '#5C4033',
        hazel: '#8E7618',
        green: '#3D6B4F',
        blue: '#4A7C9B',
        grey: '#8A9499',
        amber: '#B8860B'
      },
      skin_color: {
        'very-deep': '#422C22',
        deep: '#5E4538',
        tan: '#8D5524',
        medium: '#C68642',
        'light-medium': '#D4A574',
        light: '#E8BEAC',
        fair: '#F5DCC8',
        'very-fair': '#FCE8DC'
      }
    };

    function decorateOptionSwatches(form) {
      ['natural_hair_color', 'eye_color', 'skin_color'].forEach(function (questionKey) {
        var swatches = OPTION_SWATCHES[questionKey];
        if (!swatches) return;

        var fieldset = form.querySelector('[data-question-key="' + questionKey + '"]');
        if (!fieldset) return;

        fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var hex = swatches[input.value];
          if (!hex) return;

          var label = input.parentElement && input.parentElement.querySelector('.color-guide__option-label');
          if (!label || label.querySelector('.color-guide__color-swatch')) return;

          var swatch = document.createElement('span');
          swatch.className = 'color-guide__color-swatch';
          swatch.setAttribute('aria-hidden', 'true');
          swatch.style.backgroundColor = hex;
          label.insertBefore(swatch, label.firstChild);
        });
      });
    }

    var EYE_ORDER = [
      'black', 'dark-brown', 'medium-brown', 'hazel', 'amber', 'green', 'blue', 'grey'
    ];

    var ATTRIBUTE_WEIGHTS = {
      skin_color: 0.45,
      natural_hair_color: 0.35,
      eye_color: 0.2
    };

    var PICKER_ATTRIBUTE_WEIGHTS = {
      natural_hair_color: 0.34,
      eye_color: 0.33,
      skin_color: 0.33
    };

    var MODEL_PLACEHOLDERS = {
      aino: { color: '#E8D5B7', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/aino.png?v=1782900109' },
      bailey: { color: '#B8956A', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/bailey.png?v=1782900109' },
      cecilia: { color: '#3D2914', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/cecilia.png?v=1782900111' },
      emilie: { color: '#6B4423', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/emilie.png?v=1782900110' },
      freya: { color: '#F5F0E8', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/freya.png?v=1782901998' },
      ksenia: { color: '#D4A574', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/ksenia.png?v=1782900109' },
      lucia: { color: '#5C3317', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/lucia.png?v=1782900109' },
      mei: { color: '#8B6914', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/mei.png?v=1782900109' },
      niamh: { color: '#F0C987', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/niamh.png?v=1782900109' },
      hafsatu: { color: '#2C1810', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/hafsatu.png?v=1782900109' },
      priya: { color: '#4A3728', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/priya.png?v=1782900109' },
      rima: { color: '#7D5A3C', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/rima.png?v=1782900109' },
      oko: { color: '#5C4033', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/oko.png?v=1782900109' },
      yoki: { color: '#6F4E37', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/yoki.png?v=1782900109' },
      zofia: { color: '#C9A882', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/zofia.png?v=1782900109' }
    };

    var MALE_MODEL_PARTNERS = {
      aino: { name: 'Einar', slug: 'einar', color: '#E8D5B7', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/einar.png?v=1782906282' },
      bailey: { name: 'James', slug: 'james', color: '#B55239', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/james.png?v=1782906282' },
      cecilia: { name: 'Ananda', slug: 'ananda', color: '#8D5524', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/ananda.png?v=1782906282' },
      emilie: { name: 'Paolo', slug: 'paolo', color: '#4A3728', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/paolo.png?v=1782906282' },
      freya: { name: 'Lars', slug: 'lars', color: '#D4B896', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/lars.png?v=1782906282' },
      ksenia: { name: 'Florian', slug: 'florian', color: '#A67C52', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/florian.png?v=1782906281' },
      lucia: { name: 'Thiago', slug: 'thiago', color: '#6B4423', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/thiago.png?v=1782906281' },
      mei: { name: 'Minho', slug: 'minho', color: '#5C4033', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/minho.png?v=1782906282' },
      niamh: { name: 'Nikolai', slug: 'nikolai', color: '#B55239', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/nikolai.png?v=1782906282' },
      hafsatu: { name: 'Diallo', slug: 'diallo', color: '#422C22', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/diallo.png?v=1782906281' },
      priya: { name: 'Karim', slug: 'karim', color: '#4A3728', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/karim.png?v=1782906282' },
      rima: { name: 'William', slug: 'william', color: '#7D5A3C', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/william.png?v=1782906282' },
      oko: { name: 'Selam', slug: 'selam', color: '#5E4538', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/selam.png?v=1782906282' },
      yoki: { name: 'Chaska', slug: 'chaska', color: '#6F4E37', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/chaska.png?v=1782906281' },
      zofia: { name: 'Ivan', slug: 'ivan', color: '#2C1810', imageUrl: 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/ivan.png?v=1782906281' }
    };

    // Model wearing each AYAMI color — override URLs here as you receive them.
    // Filename pattern: pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-{colorSlug}-{modelSlug}.png
    var MODEL_COLOR_IMAGE_CDN = 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/';
    var MODEL_COLOR_LOOK_PRODUCT_PREFIX = 'pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-';
    var MODEL_COLOR_IMAGE_VERSION = '1782910409';
    var PENDING_SAVE_KEY = 'color_guide_pending_save';
    var LOCAL_SAVE_PREFIX = 'color_guide_saved_';
    var UPDATE_MODE_KEY = 'color_guide_update_mode';
    var RETAKE_QUERY_PARAM = 'color_guide_retake';
    var MODEL_COLOR_LOOKS = {
      ananda: {
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-ananda.png?v=1782910409',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-ananda.png?v=1782910409',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-ananda.png?v=1782910409',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-ananda.png?v=1782910409',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-ananda.png?v=1782910409',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-ananda.png?v=1782910409',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-ananda.png?v=1782910409',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-ananda.png?v=1782910410'
      },
      chaska: {
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-chaska.png?v=1782911166',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-chaska.png?v=1782911167',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-chaska.png?v=1782911167',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-chaska.png?v=1782911166',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-chaska.png?v=1782911166',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-chaska.png?v=1782911166',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-chaska.png?v=1782911166',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-chaska.png?v=1782911166'
      },
      diallo: {
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-diallo.png?v=1782912025',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-diallo.png?v=1782912024',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-diallo.png?v=1782912025',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-diallo.png?v=1782912025',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-diallo.png?v=1782912024',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-diallo.png?v=1782912024',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-diallo.png?v=1782912024',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-diallo.png?v=1782912025'
      },
      einar: {
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-einar.png?v=1782912422',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-einar.png?v=1782912422',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-einar.png?v=1782912421',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-einar.png?v=1782912421',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-einar.png?v=1782912421',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-einar.png?v=1782912421',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-einar.png?v=1782912421',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-einar.png?v=1782912421'
      },
      florian: {
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-florian.png?v=1782914485',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-florian.png?v=1782914484',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-florian.png?v=1782914485',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-florian.png?v=1782914484',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-florian.png?v=1782914484',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-florian.png?v=1782914484',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-florian.png?v=1782914484',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-florian.png?v=1782914483'
      },
      ivan: {
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-ivan.png?v=1782915169',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-ivan.png?v=1782915168',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-ivan.png?v=1782915168',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-ivan.png?v=1782915168',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-ivan.png?v=1782915167',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-ivan.png?v=1782915165',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-ivan.png?v=1782915166',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-ivan.png?v=1782915166'
      },
      james: {
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-james.png?v=1782915610',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-james.png?v=1782915610',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-james.png?v=1782915609',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-james.png?v=1782915610',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-james.png?v=1782915608',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-james.png?v=1782915609',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-james.png?v=1782915609',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-james.png?v=1782915610'
      },
      karim: {
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-karim.png?v=1782916414',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-karim.png?v=1782916414',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-karim.png?v=1782916413',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-karim.png?v=1782916413',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-karim.png?v=1782916413',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-karim.png?v=1782916413',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-karim.png?v=1782916413',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-karim.png?v=1782916414'
      },
      lars: {
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-lars.png?v=1782917395',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-lars.png?v=1782917395',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-lars.png?v=1782917395',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-lars.png?v=1782917394',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-lars.png?v=1782917394',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-lars.png?v=1782917394',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-lars.png?v=1782917395',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-lars.png?v=1783091671'
      },
      minho: {
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-minho.png?v=1782917807',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-minho.png?v=1782917806',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-minho.png?v=1782917808',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-minho.png?v=1782917807',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-minho.png?v=1782917807',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-minho.png?v=1782917806',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-minho.png?v=1782917806',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-minho.png?v=1782917806'
      },
      nikolai: {
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-nikolai.png?v=1782918337',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-nikolai.png?v=1782918336',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-nikolai.png?v=1782918336',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-nikolai.png?v=1782918336',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-nikolai.png?v=1782918336',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-nikolai.png?v=1782918336',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-nikolai.png?v=1782918594',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-nikolai.png?v=1782918335'
      },
      paolo: {
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-paolo.png?v=1782918903',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-paolo.png?v=1782918903',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-paolo.png?v=1782918905',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-paolo.png?v=1782918904',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-paolo.png?v=1782918904',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-paolo.png?v=1782918904',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-paolo.png?v=1782918904',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-paolo.png?v=1782918904'
      },
      selam: {
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-selam.png?v=1782919285',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-selam.png?v=1782919284',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-selam.png?v=1782919285',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-selam.png?v=1782919284',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-selam.png?v=1782919286',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-selam.png?v=1782919285',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-selam.png?v=1782919283',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-selam.png?v=1782919284'
      },
      thiago: {
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-dune-beige-thiago.png?v=1782919653',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-thiago.png?v=1782919653',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-thiago.png?v=1782919653',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-thiago.png?v=1782919652',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-thiago.png?v=1782919653',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-thiago.png?v=1782919653',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-thiago.png?v=1782919652'
      },
      william: {
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-ocean-blue-william.png?v=1783091345',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-forest-green-william.png?v=1783091303',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-agate-beige-william.png?v=1783091302',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-twilight-blue-william.png?v=1783091303',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-espresso-brown-william.png?v=1783091299',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-wine-red-william.png?v=1783091292',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-snow-white-william.png?v=1783091278',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/pulse-t-shirt-bamboo-jersey-crew-neck-short-sleeves-midnight-black-william.png?v=1783091700'
      },
      aino: {
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-aino.png?v=1782931638',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-aino.png?v=1782931638',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-aino.png?v=1782931638',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-aino.png?v=1782931638',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-aino.png?v=1782931638',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-aino.png?v=1782931638',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-dune-beige-aino.png?v=1782931637',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-aino.png?v=1782931637'
      },
      bailey: {
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-bailey.png?v=1782932103',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-emerald-green-bailey.png?v=1782932102',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-bailey.png?v=1782932102',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-bailey.png?v=1782932102',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-bailey.png?v=1782932102',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-bailey.png?v=1782932102',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-bailey.png?v=1782932103',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-bailey.png?v=1782932103'
      },
      cecilia: {
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-cecilia.png?v=1782933807',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-cecilia.png?v=1782933807',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-cecilia.png?v=1782933807',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-cecilia.png?v=1782933807',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-cecilia.png?v=1782933807',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-cecilia.png?v=1782933807',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-dune-beige-cecilia.png?v=1782933807',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-cecilia.png?v=1782933805'
      },
      emilie: {
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-emilie.png?v=1782934116',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-emilie.png?v=1782934116',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-emilie.png?v=1782934116',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-emilie.png?v=1782934115',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-emilie.png?v=1782934116',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-emilie.png?v=1782934115',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-emilie.png?v=1782934116',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-emilie.png?v=1782934115'
      },
      freya: {
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-freya.png?v=1782934393',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-freya.png?v=1782934392',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-freya.png?v=1782934391',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-freya.png?v=1782934391',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-freya.png?v=1782934391',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-dune-beige-freya.png?v=1782934392',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-freya.png?v=1782934391',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-freya.png?v=1782934391'
      },
      ksenia: {
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-ksenia.png?v=1782938444',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-ksenia.png?v=1782938444',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-ksenia.png?v=1782938444',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-dune-beige-ksenia.png?v=1782938444',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-ksenia.png?v=1782938443',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-ksenia.png?v=1782938443',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-ksenia.png?v=1782938443',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-ksenia.png?v=1782938443'
      },
      lucia: {
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-lucia.png?v=1782938655',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-lucia.png?v=1782938656',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-lucia.png?v=1782938656',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-lucia.png?v=1782938656',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-lucia.png?v=1782938655',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-lucia.png?v=1782938655',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-lucia.png?v=1782938655',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-lucia.png?v=1782938654'
      },
      oko: {
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-oko.png?v=1782939396',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-oko.png?v=1782939397',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-oko.png?v=1782939397',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-oko.png?v=1782939397',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-oko.png?v=1782939397',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-oko.png?v=1782939397',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-oko.png?v=1782939398',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-oko.png?v=1782939398'
      },
      priya: {
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-priya.png?v=1782939580',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-priya.png?v=1782939579',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-priya.png?v=1782939580',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-priya.png?v=1782939580',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-priya.png?v=1782939579',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-priya.png?v=1782939580',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-priya.png?v=1782939581',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-priya.png?v=1782939582'
      },
      rima: {
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-rima.png?v=1782939772',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-rima.png?v=1782939773',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-rima.png?v=1782939774',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-rima.png?v=1782939774',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-rima.png?v=1782939773',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-rima.png?v=1782939774',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-rima.png?v=1782939774',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-rima.png?v=1782939774'
      },
      hafsatu: {
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-hafsatu.png?v=1782940015',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-hafsatu.png?v=1782940014',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-hafsatu.png?v=1782940015',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-hafsatu.png?v=1782940016',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-hafsatu.png?v=1782940017',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-hafsatu.png?v=1782940018',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-hafsatu.png?v=1782940017',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-hafsatu.png?v=1782940017'
      },
      yoki: {
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-yoki.png?v=1782940219',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-yoki.png?v=1782940219',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-yoki.png?v=1782940220',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-yoki.png?v=1782940219',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-yoki.png?v=1782940219',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-yoki.png?v=1782940220',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-yoki.png?v=1782940220',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-yoki.png?v=1782940219'
      },
      mei: {
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-mei.png?v=1782938922',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-mei.png?v=1782938922',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-mei.png?v=1782938923',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-mei.png?v=1782938920',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-mei.png?v=1782938920',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-emerald-green-mei.png?v=1782938922',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-mei.png?v=1782938920',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-mei.png?v=1782938921'
      },
      niamh: {
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-niamh.png?v=1782939119',
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-niamh.png?v=1782939118',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-niamh.png?v=1782939118',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-niamh.png?v=1782939118',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-niamh.png?v=1782939118',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-niamh.png?v=1782939118',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-niamh.png?v=1782939118',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-niamh.png?v=1782939118'
      },
      zofia: {
        'agate-beige': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-agate-beige-zofia.png?v=1783090223',
        'wine-red': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-wine-red-zofia.png?v=1783090222',
        'espresso-brown': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-espresso-brown-zofia.png?v=1783090222',
        'forest-green': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-forest-green-zofia.png?v=1783090223',
        'midnight-black': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-midnight-black-zofia.png?v=1783090221',
        'snow-white': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-snow-white-zofia.png?v=1783090222',
        'twilight-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-twilight-blue-zofia.png?v=1783090220',
        'ocean-blue': 'https://cdn.shopify.com/s/files/1/0901/0662/6381/files/retreat-dress-maxi-length-bamboo-jersey-crew-neck-ocean-blue-zofia.png?v=1783090220'
      }
    };

    function getSteps(form) {
      return Array.prototype.slice.call(form.querySelectorAll('.color-guide__question[data-question-id]'));
    }

    function normalizeSkinValue(value) {
      var aliases = {
        'medium-deep': 'tan',
        'medium-light': 'light-medium'
      };
      return aliases[value] || value;
    }

    function getProfileAnswers(form) {
      var keys = ['natural_hair_color', 'eye_color', 'skin_color'];
      var answers = [];

      keys.forEach(function (questionKey) {
        var fieldset = form.querySelector('[data-question-key="' + questionKey + '"]');
        if (!fieldset || fieldset.hasAttribute('data-color-guide-model-step')) return;

        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) return;

        var value = checked.value;
        if (questionKey === 'skin_color') value = normalizeSkinValue(value);

        answers.push({
          questionId: fieldset.dataset.questionId,
          questionKey: questionKey,
          value: value,
          label: checked.dataset.optionLabel || checked.value
        });
      });

      return answers;
    }

    function collectAnswers(form) {
      var answers = getProfileAnswers(form);
      var modelFieldset = form.querySelector('[data-color-guide-model-step]');
      if (!modelFieldset) return answers;

      var modelInput = modelFieldset.querySelector('input[type="radio"]:checked');
      if (modelInput) {
        answers.push({
          questionId: modelFieldset.dataset.questionId,
          questionKey: modelFieldset.dataset.questionKey,
          value: modelInput.value,
          label: modelInput.dataset.optionLabel || modelInput.value
        });
      }
      return answers;
    }

    function getSelectedModelAnswer(form) {
      var modelFieldset = form.querySelector('[data-color-guide-model-step]');
      if (!modelFieldset) return null;
      var checked = modelFieldset.querySelector('input[type="radio"]:checked');
      if (!checked) return null;

      var typeSlug = checked.dataset.typeSlug || checked.value;
      var model = findModelBySlug(typeSlug);
      if (!model) return null;

      if (checked.dataset.typeSlug) {
        var partner = getMalePartner(typeSlug);
        if (!partner) return model;
        return {
          name: partner.name,
          slug: partner.slug,
          typeSlug: typeSlug,
          gender: 'male',
          hair: model.hair,
          eyes: model.eyes,
          skin: model.skin,
          warmth: model.warmth,
          lightness: model.lightness,
          contrast: model.contrast
        };
      }

      return {
        name: model.name,
        slug: model.slug,
        typeSlug: typeSlug,
        gender: 'female',
        hair: model.hair,
        eyes: model.eyes,
        skin: model.skin,
        warmth: model.warmth,
        lightness: model.lightness,
        contrast: model.contrast
      };
    }

    function getAnswerValue(answers, questionKey) {
      for (var i = 0; i < answers.length; i++) {
        if (answers[i].questionKey === questionKey) return answers[i].value;
      }
      return null;
    }

    function attributeIndex(order, value) {
      return order.indexOf(value);
    }

    function ordinalDistance(order, a, b) {
      if (!a || !b) return order.length - 1;
      var aIndex = attributeIndex(order, a);
      var bIndex = attributeIndex(order, b);
      if (aIndex === -1 || bIndex === -1) return order.length - 1;
      return Math.abs(aIndex - bIndex);
    }

    function skinDistance(a, b) {
      return ordinalDistance(SKIN_ORDER, normalizeSkinValue(a), normalizeSkinValue(b));
    }

    function hairDistance(a, b) {
      if (!a || !b) return HAIR_ORDER.length - 1;
      if (a === b) return 0;
      var distance = ordinalDistance(HAIR_ORDER, a, b);
      var redShades = ['light-medium-red', 'red-auburn'];
      if (redShades.indexOf(a) !== -1 && redShades.indexOf(b) !== -1) {
        return Math.min(distance, 1);
      }
      return distance;
    }

    function eyeDistance(a, b) {
      if (!a || !b) return EYE_ORDER.length - 1;
      if (a === b) return 0;
      var distance = ordinalDistance(EYE_ORDER, a, b);
      if (
        (a === 'amber' && b === 'hazel') ||
        (a === 'hazel' && b === 'amber') ||
        (a === 'black' && b === 'dark-brown') ||
        (a === 'dark-brown' && b === 'black')
      ) {
        return Math.min(distance, 0.5);
      }
      return distance;
    }

    function countExactAttributeMatches(profileAnswers, model) {
      var matches = 0;
      if (getAnswerValue(profileAnswers, 'natural_hair_color') === model.hair) matches++;
      if (getAnswerValue(profileAnswers, 'eye_color') === model.eyes) matches++;
      if (getAnswerValue(profileAnswers, 'skin_color') === normalizeSkinValue(model.skin)) matches++;
      return matches;
    }

    function stableHash(value) {
      var hash = 0;
      for (var i = 0; i < value.length; i++) {
        hash = ((hash << 5) - hash + value.charCodeAt(i)) | 0;
      }
      return Math.abs(hash);
    }

    function getModelProfileSignature(model) {
      return model.hair + '|' + model.eyes + '|' + normalizeSkinValue(model.skin);
    }

    function getDuplicateRank(model, profileKey) {
      var signature = getModelProfileSignature(model);
      var siblings = COLOR_MODELS.filter(function (candidate) {
        return getModelProfileSignature(candidate) === signature;
      }).sort(function (a, b) {
        return a.slug.localeCompare(b.slug);
      });

      if (siblings.length <= 1) return 0;

      var offset = stableHash(profileKey) % siblings.length;
      var rotated = siblings.slice(offset).concat(siblings.slice(0, offset));
      for (var i = 0; i < rotated.length; i++) {
        if (rotated[i].slug === model.slug) return i;
      }
      return siblings.length;
    }

    function modelAttributeDistance(profileAnswers, model, weights) {
      var hair = getAnswerValue(profileAnswers, 'natural_hair_color');
      var eyes = getAnswerValue(profileAnswers, 'eye_color');
      var skin = getAnswerValue(profileAnswers, 'skin_color');
      var attributeWeights = weights || ATTRIBUTE_WEIGHTS;

      var hairDist = hairDistance(hair, model.hair) / (HAIR_ORDER.length - 1);
      var eyeDist = eyeDistance(eyes, model.eyes) / (EYE_ORDER.length - 1);
      var skinDist = skinDistance(skin, model.skin) / (SKIN_ORDER.length - 1);

      return (
        attributeWeights.skin_color * skinDist +
        attributeWeights.natural_hair_color * hairDist +
        attributeWeights.eye_color * eyeDist
      );
    }

    function rankModelsForPicker(profileAnswers) {
      var hair = getAnswerValue(profileAnswers, 'natural_hair_color');
      var eyes = getAnswerValue(profileAnswers, 'eye_color');
      var skin = getAnswerValue(profileAnswers, 'skin_color');
      var profileKey = hair + '|' + eyes + '|' + skin;

      return COLOR_MODELS.map(function (model) {
        var hairMatch = hair === model.hair;
        var eyeMatch = eyes === model.eyes;
        var skinMatch = skin === normalizeSkinValue(model.skin);
        var distance = modelAttributeDistance(profileAnswers, model, PICKER_ATTRIBUTE_WEIGHTS);
        distance += getDuplicateRank(model, profileKey) * 0.001;

        return {
          model: model,
          distance: distance,
          hairMatch: hairMatch,
          eyeMatch: eyeMatch,
          skinMatch: skinMatch,
          exactMatches: countExactAttributeMatches(profileAnswers, model)
        };
      }).sort(function (a, b) {
        if (a.hairMatch !== b.hairMatch) return b.hairMatch - a.hairMatch;
        if (a.eyeMatch !== b.eyeMatch) return b.eyeMatch - a.eyeMatch;
        if (a.skinMatch !== b.skinMatch) return b.skinMatch - a.skinMatch;
        if (a.distance !== b.distance) return a.distance - b.distance;
        return a.model.name.localeCompare(b.model.name);
      });
    }

    function refreshModelStep(form) {
      var profileAnswers = getProfileAnswers(form);
      if (profileAnswers.length < 3) return;

      form._topMatches = rankModelsForPicker(profileAnswers).slice(0, 3);
      populateModelStep(form, form._topMatches);
    }

    function findModelBySlug(slug) {
      if (!slug) return null;
      for (var i = 0; i < COLOR_MODELS.length; i++) {
        if (COLOR_MODELS[i].slug === slug) return COLOR_MODELS[i];
      }
      return null;
    }

    function findTypeSlugForMaleSlug(maleSlug) {
      if (!maleSlug) return null;
      for (var typeSlug in MALE_MODEL_PARTNERS) {
        if (MALE_MODEL_PARTNERS.hasOwnProperty(typeSlug) && MALE_MODEL_PARTNERS[typeSlug].slug === maleSlug) {
          return typeSlug;
        }
      }
      return null;
    }

    function getMalePartner(typeSlug) {
      return MALE_MODEL_PARTNERS[typeSlug] || null;
    }

    function normalizeModelProfile(model) {
      return {
        warmth: Math.round((model.warmth / MODEL_COLOR_SCALE.warmth) * 5 * 10) / 10,
        lightness: Math.round((model.lightness / MODEL_COLOR_SCALE.lightness) * 5 * 10) / 10,
        contrast: Math.round((model.contrast / MODEL_COLOR_SCALE.contrast) * 5 * 10) / 10
      };
    }

    function buildColorTargetProfile(customerProfile, model) {
      if (!model) return customerProfile;
      var normalizedModel = normalizeModelProfile(model);
      var target = {};
      ['warmth', 'lightness', 'contrast'].forEach(function (dimension) {
        target[dimension] = Math.round(
          ((customerProfile[dimension] + normalizedModel[dimension]) / 2) * 10
        ) / 10;
      });
      return target;
    }

    function initWizard(form) {
      form._steps = getSteps(form);
      form._currentStep = 0;
      form._topMatches = [];
      showStep(form, 0);
    }

    function showStep(form, index) {
      form._currentStep = index;
      form._steps.forEach(function (step, stepIndex) {
        step.classList.toggle('color-guide__question--hidden', stepIndex !== index);
      });
      updateNavButtons(form);
      updateProgress(form);

      if (form._steps[index] && form._steps[index].hasAttribute('data-color-guide-model-step')) {
        refreshModelStep(form);
      }
    }

    function updateProgress(form) {
      var progress = form.querySelector('[data-color-guide-progress]');
      if (!progress) return;
      progress.textContent = 'Question ' + (form._currentStep + 1) + ' of ' + form._steps.length;
    }

    function updateNavButtons(form) {
      var backBtn = form.querySelector('[data-color-guide-back]');
      var nextBtn = form.querySelector('[data-color-guide-next]');
      var submitBtn = form.querySelector('.color-guide__submit');
      var isLastStep = form._currentStep === form._steps.length - 1;

      if (backBtn) backBtn.classList.toggle('hidden', form._currentStep === 0);
      if (nextBtn) nextBtn.classList.toggle('hidden', isLastStep);
      if (submitBtn) submitBtn.classList.toggle('hidden', !isLastStep);
    }

    function validateStep(fieldset) {
      var required = fieldset.querySelector('input[type="radio"][required]');
      if (!required) return true;
      var answered = !!fieldset.querySelector('input[type="radio"]:checked');
      setQuestionValidity(fieldset, answered);
      return answered;
    }

    function buildModelOptionCard(displayName, imageUrl, fallbackColor, inputValue, inputAttrs) {
      var visual = imageUrl
        ? '<img src="' + imageUrl + '" alt="' + displayName + '" loading="lazy">'
        : '<div class="color-guide__model-swatch" style="background-color:' + fallbackColor + '"></div>';

      return (
        '<label class="color-guide__model-option">' +
        '<input type="radio" name="color-guide-q4" value="' + inputValue + '" ' + inputAttrs + ' required>' +
        '<div class="color-guide__model-card">' +
        visual +
        '<span class="color-guide__model-name">' + displayName + '</span>' +
        '</div>' +
        '</label>'
      );
    }

    function populateModelStep(form, topMatches) {
      var container = form.querySelector('[data-model-options]');
      if (!container) return;

      var womenHtml = '';
      var menHtml = '';

      topMatches.forEach(function (match) {
        var model = match.model;
        var partner = getMalePartner(model.slug);
        var femalePlaceholder = MODEL_PLACEHOLDERS[model.slug] || { color: '#cccccc', imageUrl: '' };

        womenHtml += buildModelOptionCard(
          model.name,
          femalePlaceholder.imageUrl,
          femalePlaceholder.color,
          model.slug,
          'data-option-label="' + model.name + '" data-model-gender="female"'
        );

        if (partner) {
          menHtml += buildModelOptionCard(
            partner.name,
            partner.imageUrl,
            partner.color,
            partner.slug,
            'data-option-label="' + partner.name + '" data-model-gender="male" data-type-slug="' + model.slug + '"'
          );
        }
      });

      container.innerHTML =
        '<div class="color-guide__model-rows">' +
        '<div class="color-guide__model-row">' +
        '<p class="color-guide__model-row-label">Women</p>' +
        '<div class="color-guide__model-options">' + womenHtml + '</div>' +
        '</div>' +
        '<div class="color-guide__model-row">' +
        '<p class="color-guide__model-row-label">Men</p>' +
        '<div class="color-guide__model-options">' + menHtml + '</div>' +
        '</div>' +
        '</div>';
    }

    function advanceStep(form) {
      var currentFieldset = form._steps[form._currentStep];
      if (!validateStep(currentFieldset)) return;

      if (form._currentStep < form._steps.length - 1) {
        showStep(form, form._currentStep + 1);
      }
    }

    function goBack(form) {
      if (form._currentStep === 0) return;
      showStep(form, form._currentStep - 1);
    }

    function calculateScores(answers) {
      var weighted = { warmth: 0, lightness: 0, contrast: 0 };
      var weightSums = { warmth: 0, lightness: 0, contrast: 0 };

      answers.forEach(function (answer) {
        var weight = CATEGORY_WEIGHTS[answer.questionKey];
        if (!weight) return;

        var category = SCORES[answer.questionKey];
        if (!category) return;

        var points = category[answer.value];
        if (!points) return;

        if (typeof points.warmth === 'number') {
          weighted.warmth += points.warmth * weight;
          weightSums.warmth += weight;
        }
        if (typeof points.lightness === 'number') {
          weighted.lightness += points.lightness * weight;
          weightSums.lightness += weight;
        }
        if (typeof points.contrast === 'number') {
          weighted.contrast += points.contrast * weight;
          weightSums.contrast += weight;
        }
      });

      var totals = { warmth: 0, lightness: 0, contrast: 0 };
      ['warmth', 'lightness', 'contrast'].forEach(function (dimension) {
        if (weightSums[dimension] > 0) {
          totals[dimension] = Math.round((weighted[dimension] / weightSums[dimension]) * 10) / 10;
        }
      });

      return totals;
    }

    function profileDistance(profile, model) {
      var warmthDelta = profile.warmth - model.warmth;
      var lightnessDelta = profile.lightness - model.lightness;
      var contrastDelta = profile.contrast - model.contrast;
      return Math.sqrt(
        warmthDelta * warmthDelta +
        lightnessDelta * lightnessDelta +
        contrastDelta * contrastDelta
      );
    }

    function getRating(distance, tiers) {
      var ratingTiers = tiers || RATING_TIERS;
      for (var i = 0; i < ratingTiers.length; i++) {
        if (distance <= ratingTiers[i].maxDistance) return ratingTiers[i];
      }
      return ratingTiers[ratingTiers.length - 1];
    }

    function renderStarIcons(count) {
      var stars = '';
      for (var i = 0; i < count; i++) stars += '\u2B50';
      return stars;
    }

    function groupMatchesByRating(matches, tiers) {
      var ratingTiers = tiers || RATING_TIERS;
      return ratingTiers.slice().map(function (tier) {
        return {
          stars: tier.stars,
          label: tier.label,
          matches: matches.filter(function (match) {
            return match.rating.stars === tier.stars;
          }).sort(function (a, b) {
            return a.distance - b.distance;
          })
        };
      }).filter(function (group) {
        return group.matches.length > 0;
      });
    }

    function rankAyamiColors(profile) {
      return AYAMI_COLORS.map(function (color) {
        var distance = profileDistance(profile, color);
        return {
          color: color,
          distance: distance,
          rating: getRating(distance, COLOR_RATING_TIERS)
        };
      }).sort(function (a, b) {
        return a.distance - b.distance;
      }).map(function (match, index) {
        match.rank = index + 1;
        return match;
      });
    }

    function rankColorModels(profile) {
      return COLOR_MODELS.map(function (model) {
        var distance = profileDistance(profile, model);
        return {
          model: model,
          distance: distance,
          rating: getRating(distance)
        };
      }).sort(function (a, b) {
        return a.distance - b.distance;
      }).map(function (match, index) {
        match.rank = index + 1;
        return match;
      });
    }

    function formatScore(value) {
      var rounded = Math.round(value * 10) / 10;
      if (rounded > 0) return '+' + rounded;
      return String(rounded);
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function getColorGuideConfig(container) {
      if (!container) return {};
      return {
        loggedIn: container.getAttribute('data-customer-logged-in') === 'true',
        customerId: container.getAttribute('data-customer-id') || '',
        loginUrl: container.getAttribute('data-login-url') || '/account/login',
        registerUrl: container.getAttribute('data-register-url') || '/account/register',
        preferencesUrl: container.getAttribute('data-preferences-url') || '/pages/preferences',
        quizUrl: container.getAttribute('data-quiz-url') || '',
        saveUrl: container.getAttribute('data-save-url') || '/apps/ayami-color-guide/save',
      };
    }

    function buildPreferencesPayload(form) {
      var result = form && form._lastResult;
      if (!result) return null;

      return {
        saved_at: new Date().toISOString(),
        selectedModel: result.selectedModel ? {
          slug: result.selectedModel.slug,
          name: result.selectedModel.name,
          typeSlug: result.selectedModel.typeSlug || null,
          gender: result.selectedModel.gender || null
        } : null,
        colorMatches: (result.colorMatches || []).map(function (match) {
          return {
            color: {
              slug: match.color.slug,
              name: match.color.name,
              hex: match.color.hex
            },
            rating: {
              stars: match.rating.stars,
              label: match.rating.label
            },
            distance: match.distance
          };
        }),
        answers: result.answers || {}
      };
    }

    function clearPendingSave() {
      try { sessionStorage.removeItem(PENDING_SAVE_KEY); } catch (e) {}
    }

    function clearLocalSave(customerId) {
      var keys = [];
      if (customerId) keys.push(LOCAL_SAVE_PREFIX + customerId);
      keys.push(LOCAL_SAVE_PREFIX + 'active');
      keys.forEach(function (key) {
        try { sessionStorage.removeItem(key); } catch (e) {}
        try { localStorage.removeItem(key); } catch (e) {}
      });
    }

    function isUpdateMode() {
      try { return sessionStorage.getItem(UPDATE_MODE_KEY) === '1'; } catch (e) { return false; }
    }

    function setUpdateMode(enabled) {
      try {
        if (enabled) sessionStorage.setItem(UPDATE_MODE_KEY, '1');
        else sessionStorage.removeItem(UPDATE_MODE_KEY);
      } catch (e) {}
    }

    function buildQuizRetakeUrl(quizUrl) {
      if (!quizUrl) return '';
      var separator = quizUrl.indexOf('?') >= 0 ? '&' : '?';
      return quizUrl + separator + RETAKE_QUERY_PARAM + '=1';
    }

    function stripQueryParam(search, paramName) {
      return search
        .replace(new RegExp('([?&])' + paramName + '=1&?'), '$1')
        .replace(/[?&]$/, '');
    }

    function storeLocalSave(customerId, payload) {
      var serialized = JSON.stringify(payload);
      var keys = [];
      if (customerId) keys.push(LOCAL_SAVE_PREFIX + customerId);
      keys.push(LOCAL_SAVE_PREFIX + 'active');
      keys.forEach(function (key) {
        try { sessionStorage.setItem(key, serialized); } catch (e) {}
        try { localStorage.setItem(key, serialized); } catch (e) {}
      });
    }

    function loadLocalSave(customerId) {
      var keys = [];
      if (customerId) keys.push(LOCAL_SAVE_PREFIX + customerId);
      keys.push(LOCAL_SAVE_PREFIX + 'active');
      for (var i = 0; i < keys.length; i++) {
        var raw = null;
        try { raw = sessionStorage.getItem(keys[i]) || localStorage.getItem(keys[i]); } catch (e) {}
        if (!raw) continue;
        try { return JSON.parse(raw); } catch (e) {}
      }
      return null;
    }

    function readPendingSavePayload() {
      var raw = null;
      try { raw = sessionStorage.getItem(PENDING_SAVE_KEY); } catch (e) {}
      if (!raw) return null;
      try { return JSON.parse(raw); } catch (e) { return null; }
    }

    function commitPendingSave(config) {
      var payload = readPendingSavePayload();
      if (!payload) return null;
      clearPendingSave();
      storeLocalSave(config.customerId, payload);
      return payload;
    }

    function showSaveHint(container, message, isError) {
      var hint = container.querySelector('[data-color-guide-save-hint]');
      if (!hint) return;
      hint.textContent = message;
      hint.classList.toggle('hidden', !message);
      hint.classList.toggle('is-error', !!isError);
    }

    function savePreferences(config, payload) {
      payload.saved_at = new Date().toISOString();

      if (config.saveUrl) {
        return fetch(config.saveUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ preferences: payload })
        }).then(function (response) {
          if (!response.ok) {
            var error = new Error('Save failed');
            error.status = response.status;
            error.url = config.saveUrl;
            throw error;
          }
          clearPendingSave();
          storeLocalSave(config.customerId, payload);
          setUpdateMode(false);
          return { ok: true, mode: 'profile' };
        });
      }

      clearPendingSave();
      storeLocalSave(config.customerId, payload);
      setUpdateMode(false);
      return Promise.resolve({ ok: true, mode: 'local' });
    }

    function redirectToLoginForSave(config) {
      var returnPath = config.preferencesUrl || '/pages/preferences';
      var separator = returnPath.indexOf('?') >= 0 ? '&' : '?';
      var returnUrl = returnPath + separator + 'color_guide_auto_save=1';
      window.location.href = config.loginUrl + '?return_url=' + encodeURIComponent(returnUrl);
    }

    function handleSavePreferences(container, form) {
      var config = getColorGuideConfig(container);
      var payload = buildPreferencesPayload(form);
      if (!payload) return;

      if (!config.loggedIn) {
        try { sessionStorage.setItem(PENDING_SAVE_KEY, JSON.stringify(payload)); } catch (e) {}
        redirectToLoginForSave(config);
        return;
      }

      showSaveHint(container, 'Saving…', false);
      savePreferences(config, payload)
        .then(function (result) {
          if (config.preferencesUrl) {
            var suffix = result.mode === 'local' ? 'saved=1&local=1' : 'saved=1';
            window.location.href = config.preferencesUrl +
              (config.preferencesUrl.indexOf('?') >= 0 ? '&' : '?') + suffix;
            return;
          }
          showSaveHint(
            container,
            result.mode === 'local' ? 'Preferences saved on this device.' : 'Preferences saved.',
            false
          );
        })
        .catch(function (error) {
          clearPendingSave();
          storeLocalSave(config.customerId, payload);
          var message = 'Could not sync to your profile';
          if (error && error.status === 404) {
            message += ' (404 on ' + (error.url || config.saveUrl || '/apps/ayami-color-guide/save') + ')';
          } else if (error && error.status) {
            message += ' (HTTP ' + error.status + ')';
          } else {
            message += ' (server unavailable)';
          }
          message += '. Saved on this device only.';
          if (config.preferencesUrl) {
            window.location.href = config.preferencesUrl + '?saved=1&local=1';
            return;
          }
          showSaveHint(container, message, true);
        });
    }

    function renderLoginPrompt(config) {
      return (
        '<div class="color-guide__empty-state">' +
        '<p>Log in or create an account to view your saved color preferences.</p>' +
        '<div class="color-guide__actions">' +
        '<a class="button" href="' + escapeHtml(config.loginUrl) + '">Log in</a>' +
        '<a class="button button--secondary" href="' + escapeHtml(config.registerUrl) + '">Create account</a>' +
        '</div>' +
        '</div>'
      );
    }

    function renderEmptyPreferences(config) {
      var quizLink = config.quizUrl
        ? '<a class="button" href="' + escapeHtml(buildQuizRetakeUrl(config.quizUrl)) + '">Take the color guide quiz</a>'
        : '';
      return (
        '<div class="color-guide__empty-state">' +
        '<p>You have not saved any color preferences yet.</p>' +
        '<div class="color-guide__actions">' + quizLink + '</div>' +
        '</div>'
      );
    }

    function readSavedPreferencesFromPage() {
      var scriptEl = document.getElementById('ColorGuideSavedData');
      if (!scriptEl || !scriptEl.textContent.trim()) return null;
      try { return JSON.parse(scriptEl.textContent); } catch (e) { return null; }
    }

    function initSavedPreferencesPage() {
      var root = document.querySelector('[data-color-guide-saved]');
      if (!root) return;

      var target = root.querySelector('[data-color-guide-saved-content]');
      if (!target) return;

      var config = getColorGuideConfig(root);
      if (!config.loggedIn) {
        target.innerHTML = renderLoginPrompt(config);
        if (typeof window.kailaRefreshPreferencesHub === 'function') {
          window.kailaRefreshPreferencesHub();
        }
        return;
      }

      var params = new URLSearchParams(window.location.search);
      var shouldProcessPending =
        params.get('color_guide_auto_save') === '1' || !!readPendingSavePayload();

      var payload = readSavedPreferencesFromPage();
      if (!payload && shouldProcessPending) {
        payload = commitPendingSave(config);
      }
      if (!payload) {
        payload = loadLocalSave(config.customerId);
      }

      if (!payload || !payload.colorMatches || !payload.colorMatches.length) {
        target.innerHTML = renderEmptyPreferences(config);
        if (typeof window.kailaRefreshPreferencesHub === 'function') {
          window.kailaRefreshPreferencesHub();
        }
        return;
      }

      var savedBanner =
        params.get('saved') === '1' || params.get('color_guide_auto_save') === '1'
          ? 'Your preferences have been saved.'
          : '';

      target.innerHTML = renderResults({}, payload.colorMatches, payload.selectedModel, {
        savedPage: true,
        savedBanner: savedBanner,
        quizUrl: config.quizUrl
      });

      if (typeof window.kailaRefreshPreferencesHub === 'function') {
        window.kailaRefreshPreferencesHub();
      }

      if (params.get('color_guide_auto_save') === '1') {
        try {
          var cleanUrl = window.location.pathname + window.location.search
            .replace(/([?&])color_guide_auto_save=1&?/, '$1')
            .replace(/[?&]$/, '');
          window.history.replaceState({}, '', cleanUrl || window.location.pathname);
        } catch (e) {}
      }

      if (typeof window.kailaRefreshPreferencesHub === 'function') {
        window.kailaRefreshPreferencesHub();
      }
    }

    function initPendingSaveFlow() {
      var params = new URLSearchParams(window.location.search);
      if (params.get('color_guide_auto_save') !== '1') return;

      if (document.querySelector('[data-color-guide-saved]')) return;

      var container = document.querySelector('[data-color-guide-root]');
      if (!container) return;

      var config = getColorGuideConfig(container);
      if (!config.loggedIn) return;

      var payload = commitPendingSave(config);
      if (!payload) return;

      if (config.preferencesUrl) {
        window.location.replace(
          config.preferencesUrl + (config.preferencesUrl.indexOf('?') >= 0 ? '&' : '?') + 'saved=1'
        );
        return;
      }

      var result = container.querySelector('[data-color-guide-result]');
      if (result) {
        result.classList.remove('hidden');
        result.innerHTML = renderResults({}, payload.colorMatches, payload.selectedModel, {
          savedBanner: 'Your preferences have been saved.'
        });
      }
    }

    function getModelColorLookImageUrl(modelSlug, colorSlug) {
      if (!modelSlug || !colorSlug) return '';
      var modelLooks = MODEL_COLOR_LOOKS[modelSlug];
      if (modelLooks && modelLooks[colorSlug]) return modelLooks[colorSlug];
      return MODEL_COLOR_IMAGE_CDN +
        MODEL_COLOR_LOOK_PRODUCT_PREFIX +
        colorSlug + '-' + modelSlug +
        '.png?v=' + MODEL_COLOR_IMAGE_VERSION;
    }

    function renderModelColorPhoto(selectedModel, color, options) {
      if (!selectedModel || !color) return '';
      var opts = options || {};
      var imageUrl = getModelColorLookImageUrl(selectedModel.slug, color.slug);
      if (!imageUrl) return '';

      var altText = selectedModel.name + ' in ' + color.name;
      var className = opts.className || 'color-guide__match-photo';
      var onError = opts.hideOnError !== false
        ? ' onerror="this.parentElement.classList.add(\'is-hidden\')"'
        : '';

      return (
        '<div class="color-guide__match-photo-wrap">' +
        '<img class="' + className + '" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(altText) + '" loading="lazy"' + onError + '>' +
        '</div>'
      );
    }

    function renderColorMatchListItem(match, selectedModel) {
      var colorName = match.color.name;
      var photoHtml = selectedModel ? renderModelColorPhoto(selectedModel, match.color) : '';

      return (
        '<li class="color-guide__match-item">' +
        photoHtml +
        '<div class="color-guide__match-details">' +
        '<span class="color-guide__color-swatch" style="background-color:' + match.color.hex + '" aria-hidden="true"></span>' +
        '<strong>' + escapeHtml(colorName) + '</strong>' +
        '</div>' +
        '</li>'
      );
    }

    function renderResults(scores, colorMatches, selectedModel, options) {
      var opts = options || {};
      var groups = groupMatchesByRating(colorMatches, COLOR_RATING_TIERS);
      var html = opts.savedPage
        ? '<h2 class="color-guide__result-title">Your saved color preferences</h2>'
        : '<h2 class="color-guide__result-title">Your AYAMI color results</h2>';

      if (opts.savedBanner) {
        html += '<p class="color-guide__saved-banner" role="status">' + escapeHtml(opts.savedBanner) + '</p>';
      }

      if (selectedModel) {
        html +=
          '<div class="color-guide__selected-model">' +
          '<span class="color-guide__match-label">Your match</span>' +
          '<strong>' + selectedModel.name + '</strong>' +
          '</div>';
      }

      html +=
        '<p class="color-guide__colors-intro">Based on your skin, hair, and eye color' +
        (selectedModel ? ' and your chosen model (' + selectedModel.name + ')' : '') +
        ', these AYAMI colors should complement you best.</p>';

      html += '<div class="color-guide__rating-groups">';

      groups.forEach(function (group) {
        var listClass = 'color-guide__matches color-guide__matches--grouped';
        if (selectedModel) listClass += ' color-guide__matches--with-photos';

        html +=
          '<section class="color-guide__rating-group">' +
          '<h3 class="color-guide__rating-group-title">' +
          renderStarIcons(group.stars) +
          '<span>' + group.label + '</span>' +
          '</h3>' +
          '<ul class="' + listClass + '">';

        group.matches.forEach(function (match) {
          html += renderColorMatchListItem(match, selectedModel);
        });

        html += '</ul></section>';
      });

      html +=
        '</div>' +
        '<div class="color-guide__actions color-guide__result-actions">';

      if (opts.savedPage) {
        if (opts.quizUrl) {
          html += '<a class="button" href="' + escapeHtml(buildQuizRetakeUrl(opts.quizUrl)) + '">Update preferences</a>';
        }
      } else {
        var saveLabel = opts.updateMode ? 'Update preferences' : 'Save preferences';
        html +=
          '<button type="button" class="button" data-color-guide-save>' + saveLabel + '</button>' +
          '<button type="button" class="button button--secondary" data-color-guide-retake>Start over</button>' +
          '<p class="color-guide__save-hint hidden" data-color-guide-save-hint></p>';
      }

      html += '</div>';

      return html;
    }

    function showResults(form, scores, colorMatches, selectedModel) {
      var container = form.closest('.color-guide');
      if (!container) return;

      var questions = form.querySelector('[data-color-guide-questions]');
      var actions = form.querySelector('.color-guide__actions');
      var progress = form.querySelector('[data-color-guide-progress]');
      var intro = container.querySelector('.color-guide__intro');
      var result = container.querySelector('[data-color-guide-result]');

      if (questions) questions.classList.add('hidden');
      if (actions) actions.classList.add('hidden');
      if (progress) progress.classList.add('hidden');
      if (intro) intro.classList.add('hidden');

      if (result) {
        result.classList.remove('hidden');
        result.innerHTML = renderResults(scores, colorMatches, selectedModel, {
          updateMode: isUpdateMode()
        });
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
        result.focus({ preventScroll: true });
      }
    }

    function initRetakeFlow() {
      var params = new URLSearchParams(window.location.search);
      if (params.get(RETAKE_QUERY_PARAM) !== '1') return;

      var container = document.querySelector('[data-color-guide-root]');
      if (!container) return;

      var config = getColorGuideConfig(container);
      clearPendingSave();
      clearLocalSave(config.customerId);
      setUpdateMode(true);

      var form = container.querySelector('.color-guide__form');
      if (form) resetQuiz(form);

      try {
        var cleanSearch = stripQueryParam(window.location.search, RETAKE_QUERY_PARAM);
        var cleanUrl = window.location.pathname + (cleanSearch === '?' ? '' : cleanSearch);
        window.history.replaceState({}, '', cleanUrl || window.location.pathname);
      } catch (e) {}

      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function resetQuiz(form) {
      var container = form.closest('.color-guide');
      if (!container) return;

      form.reset();

      form.querySelectorAll('[data-question-id]').forEach(function (fieldset) {
        setQuestionValidity(fieldset, true);
      });

      var modelOptions = form.querySelector('[data-model-options]');
      if (modelOptions) modelOptions.innerHTML = '';

      var questions = form.querySelector('[data-color-guide-questions]');
      var actions = form.querySelector('.color-guide__actions');
      var progress = form.querySelector('[data-color-guide-progress]');
      var intro = container.querySelector('.color-guide__intro');
      var result = container.querySelector('[data-color-guide-result]');

      if (questions) questions.classList.remove('hidden');
      if (actions) actions.classList.remove('hidden');
      if (progress) progress.classList.remove('hidden');
      if (intro) intro.classList.remove('hidden');
      if (result) {
        result.classList.add('hidden');
        result.innerHTML = '';
      }

      initWizard(form);
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function setQuestionValidity(fieldset, isValid) {
      fieldset.classList.toggle('is-invalid', !isValid);
      var error = fieldset.querySelector('[data-question-error]');
      if (error) error.classList.toggle('hidden', isValid);
    }

    function handleSubmit(form) {
      var currentFieldset = form._steps[form._currentStep];
      if (!validateStep(currentFieldset)) return;

      var answers = collectAnswers(form);
      var profileAnswers = getProfileAnswers(form);
      var scores = calculateScores(profileAnswers);
      var modelMatches = rankColorModels(scores);
      var selectedModel = getSelectedModelAnswer(form);
      var targetProfile = buildColorTargetProfile(scores, selectedModel);
      var colorMatches = rankAyamiColors(targetProfile);

      document.dispatchEvent(new CustomEvent('color-guide:submit', {
        detail: {
          answers: answers,
          scores: scores,
          targetProfile: targetProfile,
          modelMatches: modelMatches,
          colorMatches: colorMatches,
          selectedModel: selectedModel,
          form: form
        },
        bubbles: true
      }));

      form._lastResult = {
        answers: answers,
        scores: scores,
        colorMatches: colorMatches,
        selectedModel: selectedModel
      };

      showResults(form, scores, colorMatches, selectedModel);
    }

    document.querySelectorAll('.color-guide__form').forEach(function (form) {
      decorateOptionSwatches(form);
      initWizard(form);
    });

    initRetakeFlow();
    initPendingSaveFlow();
    initSavedPreferencesPage();

    document.addEventListener('click', function (event) {
      var saveBtn = event.target.closest('[data-color-guide-save]');
      if (saveBtn) {
        var saveContainer = saveBtn.closest('[data-color-guide-root]') || saveBtn.closest('.color-guide');
        if (!saveContainer) return;
        var saveForm = saveContainer.querySelector('.color-guide__form');
        if (saveForm) handleSavePreferences(saveContainer, saveForm);
        return;
      }

      var retake = event.target.closest('[data-color-guide-retake]');
      if (retake) {
        var container = retake.closest('.color-guide');
        if (!container) return;
        var form = container.querySelector('.color-guide__form');
        if (form) resetQuiz(form);
        return;
      }

      var next = event.target.closest('[data-color-guide-next]');
      if (next) {
        var nextForm = next.closest('.color-guide__form');
        if (nextForm) advanceStep(nextForm);
        return;
      }

      var back = event.target.closest('[data-color-guide-back]');
      if (back) {
        var backForm = back.closest('.color-guide__form');
        if (backForm) goBack(backForm);
      }
    });

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
      var fieldset = input.closest('[data-question-id]');
      if (!fieldset) return;
      setQuestionValidity(fieldset, true);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.classList.contains('color-guide__form')) return;
      event.preventDefault();
      handleSubmit(form);
    });
})();